import { EQUIPMENT_CATEGORY_ID } from '../helpers/costcodeHelpers';
import { rowHasMappedKey } from './sharedImportHelpers';

export const validateCostCodeConflict = (row, categoryId) => {
  const hasEquipmentCategory = categoryId === EQUIPMENT_CATEGORY_ID;
  const hasHourlyWage = rowHasMappedKey(row, 'hourlyWage');
  const hasDailyWage = rowHasMappedKey(row, 'dailyWage');
  const hasWageAdjustment = rowHasMappedKey(row, 'wageAdjustment');
  const hasWageMultiplier = rowHasMappedKey(row, 'wageMultiplier');
  const hasHourlyBillingRate = rowHasMappedKey(row, 'hourlyBillingRate');
  const hasDailyBillingRate = rowHasMappedKey(row, 'dailyBillingRate');

  if (!hasEquipmentCategory && hasHourlyWage && hasDailyWage) {
    throw new Error('Hourly Wage and Daily Wage cannot both be mapped for the same cost code, unless the category is Equipment');
  }
  if ((hasHourlyWage || hasDailyWage) && (hasWageAdjustment || hasWageMultiplier)) {
    throw new Error('Wage fields cannot be combined with Wage Adjustment or Wage Multiplier');
  }
  if (hasWageAdjustment && hasWageMultiplier) {
    throw new Error('Wage Adjustment and Wage Multiplier cannot both be mapped for the same cost code');
  }
  if (hasHourlyBillingRate && hasDailyBillingRate) {
    throw new Error('Hourly Billing Rate and Daily Billing Rate cannot both be mapped for the same cost code');
  }
};
